module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-bottom-01.2@2x.054e3e02.jpg";